import { Routes } from '@angular/router';
import { MarketplaceLayoutComponent } from './layout/marketplace-layout/marketplace-layout.component';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: MarketplaceLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./features/results/results.component').then((m) => m.ResultsComponent),
      },
      {
        path: 'property/:apartmentId',
        loadComponent: () =>
          import('./features/property/property.component').then((m) => m.PropertyComponent),
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'checkout/:apartmentId',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/checkout/checkout.component').then((m) => m.CheckoutComponent),
      },
      {
        path: 'booking/:orderId',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/confirmation/confirmation.component').then(
            (m) => m.ConfirmationComponent,
          ),
      },
      {
        path: 'trips',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/trips/trips.component').then((m) => m.TripsComponent),
      },
      {
        path: 'trips/:orderId',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/trips/trip-detail.component').then((m) => m.TripDetailComponent),
      },
    ],
  },
  {
    // Co-branded Property Manager landing — stands alone (its own header/footer).
    path: 'h/:slug',
    loadComponent: () =>
      import('./features/pm-landing/pm-landing.component').then((m) => m.PmLandingComponent),
  },
  { path: '**', redirectTo: '' },
];
